<template>
  <div class="page px-5">
    <page-layout>
      <h3
        v-if="this.$route.path.endsWith('/clients/new')"
        slot="header"
        class="my-4 text-truncate"
      >
        New Client
      </h3>
      <h3
        v-else
        slot="header"
        class="my-4 text-truncate"
      >
        Edit Client
      </h3>
      <client-detail-form />
    </page-layout>
  </div>
</template>

<script>
import PageLayout from "@/components/shared/PageLayout.vue";
import ClientDetailForm from "@/components/tenants/clients/ClientDetailForm.vue";
export default {
  name: "ClientDetail",
  components: {
    PageLayout,
    ClientDetailForm
  }
};
</script>
